import React from 'react';
import './Page.css';
import StoryComponent from "../componetns/menu/worldMap/StoryComponent";


function Story() {

    return (
        <div className="main_work_field">
            <StoryComponent />
        </div>
    );
}

export default Story;